import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { SubTitle } from '../../Classes/ClassForm/ClassForm.styles';
import { readOnlyLabelTableText } from '../../../constants/GlobalTexts';
import Header from "../../Bases/Header";
import { EditFormFields, EditForm, FormFieldRow } from "../../Bases/EditForm.styles";
import { InputWrapperMedium } from "../../../common/FormElementWrappers/FormElementWrappers.styles";
import Dropdown from "../../../components/Dropdown/Dropdown";
import ImageForm from "../../../components/ImageForm/ImageForm";

const EditClassSize: FC = () => {
  const {
    classId: classIdParam,
    sizeId: sizeIdParam
  } = useParams<{ classId: string, sizeId: string }>();
  const classId = +(classIdParam ?? '-1');
  const sizeId = +(sizeIdParam ?? '-1');

  return (
      <>
        <Header
            breadcrumb={{ label: 'Back to Class-Size Table', to: '/tables/classsizes' }}
            title={`View Class ${classId} | Size ${sizeId}`}
        />
        <EditForm>
          <EditFormFields>
            <FormFieldRow>
              <InputWrapperMedium>
                <Dropdown
                    label={"Class Number"}
                    id={'classNo'}
                    name={'classNo'}
                    value={classId.toString()}
                    disabled
                />
              </InputWrapperMedium>
              <InputWrapperMedium>
                <Dropdown
                    label={"Size Number"}
                    id={'sizeNo'}
                    name={'sizeNo'}
                    value={sizeId.toString()}
                    disabled
                />
              </InputWrapperMedium>
            </FormFieldRow>
            <ImageForm
                attribute={'size'}
                resourceNo={[classId, sizeId]}
            />
          </EditFormFields>
          <SubTitle>{readOnlyLabelTableText}</SubTitle>
        </EditForm>
      </>
  );
};

export default EditClassSize;